<template>
  <div class="p-4 flex border-b">
    <slot />
  </div>
</template>

<script>
export default {
  name: "LContainerToolbar"
};
</script>
